import { render, staticRenderFns } from "./SolicitarTicket.vue?vue&type=template&id=a36766a8&scoped=true"
import script from "./SolicitarTicket.vue?vue&type=script&lang=js"
export * from "./SolicitarTicket.vue?vue&type=script&lang=js"
import style0 from "./SolicitarTicket.vue?vue&type=style&index=0&id=a36766a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36766a8",
  null
  
)

export default component.exports